import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { Door } from '@models/doors';
import { FieldHeader } from '@models/companies';
import { BulkUpdateDoorTradesRequest } from './bulk-update-door-trades-request.model';
import { HardwareAssignmentRequest } from './hardware-assignment-request.model';

@Service()
export class AdminDoorDataService {
  private readonly http = inject(HttpService);

  async getDoorsAsync(projectId: string): Promise<Door[]> {
    return await this.http.getObjectAsync<Door[]>(`projects/${projectId}/doors`);
  }

  async bulkUpdateDoorTradesAsync(projectId: string, request: BulkUpdateDoorTradesRequest): Promise<number> {
    return await this.http.putObjectAsync<BulkUpdateDoorTradesRequest, number>(`projects/${projectId}/doors/companyTrades`, request);
  }

  async getDoorFieldHeadersAsync(mbeProjectId: string): Promise<FieldHeader[]> {
    return await this.http.getObjectAsync<FieldHeader[]>(`mbeHeaders/${mbeProjectId}`);
  }

  async getGenericDoorFieldHeadersAsync(): Promise<FieldHeader[]> {
    return await this.http.getObjectAsync<FieldHeader[]>('mbeHeaders');
  }

  async assignHardwareToCompanyAsync(projectId: string, companyId: string, assignments: HardwareAssignmentRequest[]): Promise<number> {
    return await this.http.putObjectAsync<HardwareAssignmentRequest[], number>(`projects/${projectId}/doors/hardware/mounters/${companyId}`, assignments);
  }

  async removeHardwareCompanyAsync(projectId: string, assignments: HardwareAssignmentRequest[]): Promise<number> {
    return await this.http.putObjectAsync<HardwareAssignmentRequest[], number>(`projects/${projectId}/doors/hardware/mounters/null`, assignments);
  }
}
